module.exports = __webpack_public_path__ + "img/page_item3.be39d869.png";